// This file is generated by next-core EcmascriptClientReferenceModule.
const { createClientModuleProxy } = require("react-server-dom-turbopack/server");

__turbopack_context__.n(createClientModuleProxy("[project]/momira.app/web/node_modules/next/dist/esm/lib/framework/boundary-components.js"));
